/**
 * Which screen the auth gate shows, as a pure decision.
 *
 * Extracted for the same reason the org dashboard extracted `buildAuthValue`
 * (PR #566 review): the branching is the part that can be wrong, and it is the
 * part a JSX component makes awkward to test. This console has no DOM test
 * harness, so a pure function is the difference between the decision being
 * covered and not.
 *
 * The distinction that matters — and the reason vista#671 touched this file's
 * component at all — is between "not signed in" and "signed in but not
 * permitted". A Sign In affordance helps the first and is a dead end for the
 * second: the user is already authenticated, so signing in again returns them
 * to the same refusal. Offering it invites them to try the one thing that
 * cannot work.
 */
export function chooseAuthScreen({ loading, isAuthenticated, errorType }) {
  if (loading) return 'loading';
  if (isAuthenticated) return 'app';

  switch (errorType) {
    // Not signed in. An anchor the user clicks reaches CF Access without the
    // redirect loop the timed navigation could produce (vista#372).
    case 'auth_failed':
      return 'sign_in';
    // The user was authenticated a moment ago, or we could not reach the API.
    // Retry is the useful affordance; Sign In would be misleading.
    case 'session_expired':
    case 'error':
      return 'retry';
    // Signed in, not an admin. No affordance — only an operator can change it.
    default:
      return 'denied';
  }
}
